import { PdfCreditType } from '../enums/pdf-credit-type.enum';

export class PdfCreditTypeHelper {
  public static buildPdfMergeNotificationCardMessage(length: number, pdfDocumentType: PdfCreditType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };

    if (pdfDocumentType === PdfCreditType.Credit) {
      msg = {
        msgPlural: `PDF de ${length} factures d'avoir`,
        msgSingular: `PDF de ${length} facture d'avoir`,
      };
    }

    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static buildPdfMergeNotifyMessage(length: number, pdfDocumentType: PdfCreditType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };

    if (pdfDocumentType === PdfCreditType.Credit) {
      msg = {
        msgPlural: `PDF multiple de ${length} avoirs en cours de génération`,
        msgSingular: `PDF multiple de ${length} avoir en cours de génération`,
      };
    }

    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static translateEnum(enumValue: PdfCreditType, pluralFlag = false): string | undefined {
    if (enumValue === PdfCreditType.Credit) {
      return pluralFlag ? "Factures d'avoir" : "Facture d'avoir";
    }
    return undefined;
  }
}
